import { ModuleOptionsModel } from '../models/moduleOptions.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModuleConfigurationService {
  public options: ModuleOptionsModel;
}
